import controller from './organization-details.controller';

const template = require('./organization-details.html');

export default {
    controller,
    template
};
